import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { Course } from '@/domain/entities/problem/course'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { CourseModuleName } from '@/store/modules/modules'

export class CourseViewModel {
  private store = useStore()

  courseList: ComputedRef<{ [id: number]: Course }> = computed(
    () => this.store.getters[`${CourseModuleName}/courseList`]
  )

  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${CourseModuleName}/isLoading`])

  error: ComputedRef<string | null> = computed(() => this.store.getters[`${CourseModuleName}/error`])

  async getCourseList(displayLanguage: DisplayLanguageType): Promise<void> {
    await this.store.dispatch(`${CourseModuleName}/getCourseList`, { displayLanguage })
  }

  async getCourseById(displayLanguage: DisplayLanguageType, courseId: number): Promise<void> {
    await this.store.dispatch(`${CourseModuleName}/getCourseById`, { displayLanguage, courseId })
  }
}
